import { moduleLogger } from "./util";
import { sheetV1 } from "@otto-ec/otto-components/sheet";
import { toggle } from "@otto-ec/global-resources/toggle";

type UrlData = {
	url: string;
	sheetUrl: string;
};

const STORAGE_KEY = "benefit_tag_url";

function getStoredUrl(): UrlData | null {
	const stored = sessionStorage.getItem(STORAGE_KEY);
	if (!stored) return null;

	const parsed = JSON.parse(stored);
	return {
		url: parsed.url,
		sheetUrl: parsed.sheetUrl,
	};
}

function clearStoredUrl(): void {
	sessionStorage.removeItem(STORAGE_KEY);
	moduleLogger.debug("Stored URL cleared");
}

if (toggle.get("ftnine_benefit_auto_open_sheet", false)) {
	document.addEventListener("DOMContentLoaded", () => {
		setTimeout(async () => {
			const currentOpenSheet = await sheetV1.getOpenSheet();
			if (currentOpenSheet) {
				return;
			}
			const storedData = getStoredUrl();
			if (storedData) {
				const currentUrl = window.location.href;
				if (currentUrl === storedData.url) {
					const sheet = await sheetV1.create({
						url: storedData.sheetUrl,
					});
					sheet.open = true;
					clearStoredUrl();
				}
			}
		}, 300);
	});
}
